<xemex-page-header
  [title]="locationAddress"
  [subtitle]="locationSubtitle"
  [breadcrumbs]="breadcrumbs"
  [loading]="isLoading"
  [withBackground]="true"
  [withTabBar]="false"
  [icon]="'home_work'"
>
</xemex-page-header>

<xemex-page-body [scrollable]="true">
  <xemex-location-general-tab
    [locationDetail]="locationDetail"
    [isLoading]="isLoading"
    [permissions]="permissions()"
    [userPartnerOid]="getActivePartner()?.partnerOid"
    [servicesByLocationId]="servicesByLocationId"
    [devicesByLocationId]="devicesByLocationId"
    [isLoadingServices]="isLoadingLocationServices"
    [isLoadingDevices]="isLoadingDevices"
    [showInstallations]="showInstallations()"
    [canCreateInstallation]="canCreateInstallation()"
    [installationsRevision]="locationStore.installationsRevision()"
    (updateLocation)="updateLocation($event)"
    (viewPartner)="onViewPartner($event)"
    (viewDevice)="onViewDevice($event)"
    (linkDevice)="onLinkDevice($event)"
    (coordinatesChanged)="reloadLocation()"
  ></xemex-location-general-tab>
</xemex-page-body>
